import React from 'react';
import styles from './PageTemplate.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const PageTemplate = ({children, ...props}) => {
  return (
    <div className={cx('PageTemplate')} {...props}>{children}</div>
  );
};

export default PageTemplate;